import { render } from "./Design_Email_Template.vue?vue&type=template&id=fff2e43a&scoped=true"
import script from "./Design_Email_Template.vue?vue&type=script&lang=js"
export * from "./Design_Email_Template.vue?vue&type=script&lang=js"

import "./Design_Email_Template.vue?vue&type=style&index=0&id=fff2e43a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fff2e43a"]])

export default __exports__